export default __webpack_public_path__ + "static/media/DotsEco.af76e163.png";